<template>
            <ion-card
  v-if="item.idBlockType === 2"
  :style="{ '--i': i }"
  class="learning-card"
>
  <ion-card-header>
    <div class="header-content">
      <ion-card-title class="classtitle text-20">{{ item.learningChapter.title['it-IT'] }}</ion-card-title>
      <div class="lock-status" :class="{ locked: !item.learningChapter.sbloccato, unlocked: item.learningChapter.sbloccato }">
        <ion-icon v-if="item.learningChapter.sbloccato" :icon="lockOpen"></ion-icon>
        <ion-icon v-if="!item.learningChapter.sbloccato" :icon="lockClosed"></ion-icon>
      </div>
    </div>
  </ion-card-header>
  <ion-card-content>
    <template v-if="item.learningChapter.immagine_capitolo === null">
      <VideoPlayer
      allowfullscreen
        v-if="item.learningChapter.embed_contenuto_formativo"
        :url="extractSrcFromIframe(item.learningChapter.embed_contenuto_formativo)"
        @watch_session_ended="handleWatchSessionEnded($event, item.learningChapter)"
      />
      <p class="description">{{ item.learningChapter.description['it-IT'] }}</p>
      <div v-if="item.learningChapter.id_survey" class="quiz-section">
        <ion-button expand="block" style="margin-left: 4rem;" @click="openChapter(item.learningChapter)">
          FAI IL TEST
        </ion-button>
        <div class="progress-container">
          <div class="progress-bar" :style="{ width: item.learningChapter.percentualeCompletamento + '%' }"></div>
        </div>
        <p class="percentage-survey">
          {{ item.learningChapter.RisposteEsatte }}/{{ item.learningChapter.RisposteTotali }} risposte corrette
        </p>
      </div>
    </template>
    <template v-else>
      <div class="chapter-image" v-if="item.learningChapter.immagine_capitolo">
        <img :src="item.learningChapter.immagine_capitolo" alt="Chapter Image" />
      </div>
      <p class="description">{{ item.learningChapter.description['it-IT'] }}</p>
    </template>
  </ion-card-content>
</ion-card>
</template>
<script>
import { defineComponent } from "vue";
import { lockOpen, lockClosed } from "ionicons/icons";
import VideoPlayer from "@/components/VideoPlayer.vue";
import ApiService from "../../common/service.api";
import{ useQuizStore} from "@/stores/useQuizStore";
import MasterLayout from "../MasterLayout.vue";
const quizStore = useQuizStore();
export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
      VideoPlayer,
      MasterLayout
  },
  data() {
    return {
      lockOpen,
      lockClosed,
    };
  },
  mounted() {

  this.handleWatchSessionEnded();
  },
  methods: {
    extractSrcFromIframe(iframeString) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = iframeString;
  const iframe = tempDiv.querySelector('iframe');
  return iframe ? iframe.src : null;
},
  
async handleWatchSessionEnded(event, learningChapter){
const res = await  ApiService.put("LearningVideo/Put/2", {
   id:learningChapter.id ,
idUser:  this.$store.getters["user/getUserData"].id ,
idLearning: this.$route.params.id ,
duration: event.durata ,
watchTime: event.tempoGuardato ,
remainingTime: event.tempoRimanente ,
progressPercentage: event.percentualeGuardata ,
 })
},
    openChapter: function (learningChapter) {
      if (learningChapter.id_survey) {
        quizStore.setParentId(this.$route.params.id);
        quizStore.setParent(learningChapter.id_categoria);
        quizStore.setParentTitle(learningChapter.title['it-IT']);

        this.$router.push({
  name: "campaign_quiz",
  params: {
    chapter: learningChapter.id,
    id: learningChapter.id_survey,
    title: learningChapter.title,
    parentId: this.$route.params.id,
    parent: learningChapter.id_categoria,
    parentTitle: learningChapter.title['it-IT'],
  },
});

        return;
      }
    },
  },
});
</script>
<style scoped>
.badge-text {
  font-size: 14px;
  font-weight: 600;
}

.text-20 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-transform: capitalize;
  color: white;
}
.progress-bar {
  height: 100%;
  background: white;
  transition: width 0.3s ease;
}
ion-card-header {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.4s ease forwards;
}
.learning-card {
  background: var(--JCardBg) !important;
  color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.learning-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
}
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lock-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.lock-status.locked ion-icon {
  color: #FF4757;
}
.lock-status.unlocked ion-icon {
  color: #2ECC71;
}
.classtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: bold;
  margin: 8px 0;
}
.description {
  margin: 16px 0;
  line-height: 1.6;
}
.quiz-section {
  margin-top: 20px;
}
.percentage-survey {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.8;
}
.chapter-image img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 10px;
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}



</style>

